<div class="box">
	<ui-bb-box-icon type="primary"><i class="{{ icon }}"></i></ui-bb-box-icon>
	<div class="info">
		<p class="info__title"><ng-content></ng-content></p>
		<p class="info__subTitle">{{ subTitle }}</p>
	</div>
</div>
